import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { VisionSection } from './components/VisionSection';
import { MaterialSection } from './components/MaterialSection';
import { ImpactSection } from './components/ImpactSection';
import { LocationSection } from './components/LocationSection';
import { TeamSection } from './components/TeamSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <VisionSection data-id="element-4" />
        <MaterialSection data-id="element-5" />
        <ImpactSection data-id="element-6" />
        <LocationSection data-id="element-7" />
        <TeamSection data-id="element-8" />
        <CtaSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}